function initializeMobileMenu() {
  const hamburgerButton = document.getElementById("hamburger-button");
  const mobileMenu = document.getElementById("mobile-menu");
  const closeButton = document.getElementById("mobile-menu-close-button");

  function closeMobileMenu() {
    if (mobileMenu.classList.contains("is-active")) {
      hamburgerButton.setAttribute("aria-expanded", "false");
      hamburgerButton.classList.remove("is-active");
      mobileMenu.classList.remove("is-active");
      mobileMenu.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-menu-active");

      // Also close all dropdowns when the main menu is closed
      const allOpenSubMenus = mobileMenu.querySelectorAll(
        ".sub-menu.is-active"
      );
      allOpenSubMenus.forEach((subMenu) => {
        subMenu.classList.remove("is-active");
      });
      const allActiveToggles = mobileMenu.querySelectorAll(
        ".dropdown-toggle.is-active"
      );
      allActiveToggles.forEach((toggle) => {
        toggle.classList.remove("is-active");
        toggle.setAttribute("aria-expanded", "false");
        toggle.innerHTML = "+";
      });
    }
  }

  function openMobileMenu() {
    if (!mobileMenu.classList.contains("is-active")) {
      hamburgerButton.setAttribute("aria-expanded", "true");
      hamburgerButton.classList.add("is-active");
      mobileMenu.classList.add("is-active");
      mobileMenu.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-menu-active");
    }
  }

  if (hamburgerButton && mobileMenu) {
    hamburgerButton.addEventListener("click", (event) => {
      event.stopPropagation(); // Prevent click from bubbling to document listener
      const isExpanded =
        hamburgerButton.getAttribute("aria-expanded") === "true" || false;
      if (isExpanded) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent click from bubbling to document listener
        closeMobileMenu();
      });
    }

    // Close menu when a link inside the mobile menu is clicked
    mobileMenu.addEventListener("click", (event) => {
      if (event.target.tagName === "A" && mobileMenu.contains(event.target)) {
        closeMobileMenu();
      }
      // Prevent clicks inside the menu from bubbling to the document listener
      event.stopPropagation();
    });

    // Close menu if viewport resizes and hamburger is no longer visible
    window.addEventListener("resize", () => {
      const hamburgerIsHidden =
        getComputedStyle(hamburgerButton).display === "none";
      const menuIsActive = mobileMenu.classList.contains("is-active");

      if (hamburgerIsHidden && menuIsActive) {
        closeMobileMenu();
      }
    });

    // Add event listener to the document to close menu on outside click
    document.addEventListener("click", (event) => {
      const menuIsActive = mobileMenu.classList.contains("is-active");
      // Check if the menu is active and the click is outside the menu and not on the hamburger button
      if (
        menuIsActive &&
        !mobileMenu.contains(event.target) &&
        event.target !== hamburgerButton &&
        !hamburgerButton.contains(event.target)
      ) {
        closeMobileMenu();
      }
    });
  }
}

function initializeMobileMenuDropdowns() {
  const mobileMenu = document.getElementById("mobile-menu");
  if (!mobileMenu) return;

  const menuItemsWithChildren = mobileMenu.querySelectorAll(
    ".menu-item-has-children"
  );

  menuItemsWithChildren.forEach((item) => {
    // Find the direct sub-menu
    const subMenu = item.querySelector(":scope > .sub-menu");
    if (!subMenu) return;

    // Create and insert the toggle button
    const toggleButton = document.createElement("button");
    toggleButton.innerHTML = "+";
    toggleButton.classList.add("dropdown-toggle");
    toggleButton.setAttribute("aria-expanded", "false");
    toggleButton.setAttribute("aria-label", "Alt menüyü aç/kapat");
    // Insert the button inside the li, after the a tag
    item.appendChild(toggleButton);

    toggleButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isExpanded = subMenu.classList.contains("is-active");

      if (isExpanded) {
        subMenu.classList.remove("is-active");
        toggleButton.classList.remove("is-active");
        toggleButton.setAttribute("aria-expanded", "false");
        toggleButton.innerHTML = "+";
      } else {
        subMenu.classList.add("is-active");
        toggleButton.classList.add("is-active");
        toggleButton.setAttribute("aria-expanded", "true");
        toggleButton.innerHTML = "+"; // The cross is handled by CSS rotation
      }
    });
  });
}

// Initialize the mobile menu when the DOM is ready
if (document.readyState === "loading") {
  // Loading hasn't finished yet
  document.addEventListener("DOMContentLoaded", initializeMobileMenu);
  document.addEventListener("DOMContentLoaded", initializeMobileMenuDropdowns);
} else {
  // `DOMContentLoaded` has already fired
  initializeMobileMenu();
  initializeMobileMenuDropdowns();
}
